import { tokens } from '@mindtickle/styles/lib';
export const BANNER_TYPE = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const;

export type BannerType = keyof typeof BANNER_TYPE;

export const BANNER_ICON_MAP = {
  [BANNER_TYPE.INFO]: 'INFO2',
  [BANNER_TYPE.WARNING]: 'SETTINGS_FILLED',
  [BANNER_TYPE.ERROR]: 'ERROR',
  [BANNER_TYPE.SUCCESS]: 'SUCCESS',
} as const;

export const BANNER_COLORS = {
  [BANNER_TYPE.INFO]: {
    border: `1px solid ${tokens.borderTokens.COLOR_BORDER_INFO}`,
    background: tokens.bgTokens.COLOR_BG_INFO,
    icon: tokens.iconTokens.COLOR_ICON_INFO,
  },
  [BANNER_TYPE.WARNING]: {
    border: `1px solid ${tokens.borderTokens.COLOR_BORDER_WARNING}`,
    background: tokens.bgTokens.COLOR_BG_WARNING,
    icon: tokens.iconTokens.COLOR_ICON_WARNING,
  },
  [BANNER_TYPE.ERROR]: {
    border: `1px solid ${tokens.borderTokens.COLOR_BORDER_DANGER}`,
    background: tokens.bgTokens.COLOR_BG_DANGER,
    icon: tokens.iconTokens.COLOR_ICON_DANGER,
  },
  [BANNER_TYPE.SUCCESS]: {
    border: `1px solid ${tokens.borderTokens.COLOR_BORDER_SUCCESS}`,
    background: tokens.bgTokens.COLOR_BG_SUCCESS,
    icon: tokens.iconTokens.COLOR_ICON_SUCCESS,
  },
} as const;

export interface BannerData {
  bannerText: string;
  icon?: string;
  isBannerClosable?: boolean;
  bannerType?: BannerType;
}

export interface MaintenanceBannerData extends BannerData {
  endTime: number;
  startTime: number;
  cookieName: string;
  bannerHideDurationSeconds?: number;
}

export interface BannerProps {
  bannerData: Record<string, BannerData>;
  setBannerData: (data: Record<string, BannerData>) => void;
  route: string;
  currentBannerData: BannerData & Partial<MaintenanceBannerData>;
}
